import { useCallback, useMemo, useState } from 'react'

import { getCurrentShiftPosition } from 'modules/Monitoring/agent/AgentAttendanceDetails/utils/getCurrentShiftPosition'
import { ActionDropdown } from 'modules/Monitoring/components/ActionDropdown/ActionDropdown'
import { AgentAttendanceShort } from 'modules/Monitoring/types'

const sortingOptions = [
  {
    key: 'earliestShift',
    value: 'earliestShift',
    label: 'Earliest shift',
  },
  {
    key: 'latestShift',
    value: 'latestShift',
    label: 'Latest shift',
  },
  {
    key: 'status',
    value: 'status',
    label: 'Status',
  },
  {
    key: 'shiftQueue',
    value: 'shiftQueue',
    label: 'Shift queue',
  },
]
export const useAgentsSorting = (agents: AgentAttendanceShort[]) => {
  const [activeSorting, setActiveSorting] = useState(sortingOptions[0].value)

  const sortedAgents = useMemo(() => {
    const agentsCopy = [...agents]

    switch (activeSorting) {
      case 'earliestShift':
        return agentsCopy.sort((a, b) => b.shift.startDate - a.shift.startDate)

      case 'latestShift':
        return agentsCopy.sort((a, b) => a.shift.startDate - b.shift.startDate)

      case 'status':
        return agentsCopy.sort((a, b) => {
          const statusA = a.agent.currentStatus
          const statusB = b.agent.currentStatus

          if (!statusA && statusB) {
            return 1
          }
          if (statusA && !statusB) {
            return -1
          }
          if (!statusA && !statusB) {
            return b.shift.startDate - a.shift.startDate
          }

          const statusComparison = statusA!.localeCompare(statusB!)
          if (statusComparison !== 0) {
            return statusComparison
          }

          return b.shift.startDate - a.shift.startDate
        })

      case 'shiftQueue':
        return agentsCopy.sort((a, b) => {
          const { currentPosition: positionA } = getCurrentShiftPosition(
            a.shift.positions,
          )
          const { currentPosition: positionB } = getCurrentShiftPosition(
            b.shift.positions,
          )
          const queueA = positionA?.name
          const queueB = positionB?.name

          if (!queueA && queueB) {
            return 1
          }
          if (queueA && !queueB) {
            return -1
          }
          if (queueA == null && queueB == null) {
            return b.shift.startDate - a.shift.startDate
          }

          const queueComparison = queueA!.localeCompare(queueB!)

          if (queueComparison !== 0) {
            return queueComparison
          }

          return b.shift.startDate - a.shift.startDate
        })

      default:
        return agentsCopy
    }
  }, [agents, activeSorting])

  const handleSortingReset = useCallback(() => {
    setActiveSorting(sortingOptions[0].value)
  }, [])

  return {
    sortedAgents,
    AgentsSorting: (
      <ActionDropdown
        label="Agent sotring"
        options={sortingOptions}
        value={activeSorting}
        onSelect={setActiveSorting}
      />
    ),
    onSortingReset: handleSortingReset,
  }
}
